import { useParams } from 'react-router-dom';
import PaymentOrderReport from '../components/payments/PaymentOrderReport';

export default function PaymentOrderDetail() {
    const { orderId } = useParams();
    return <PaymentOrderReport key={orderId} orderId={orderId} />;
}
